import { render, staticRenderFns } from "./api-select.vue?vue&type=template&id=050b8163&scoped=true&"
import script from "./api-select.vue?vue&type=script&lang=js&"
export * from "./api-select.vue?vue&type=script&lang=js&"
import style0 from "./api-select.vue?vue&type=style&index=0&id=050b8163&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050b8163",
  null
  
)

export default component.exports